import React from 'react'
import MetaTags from '../seo/MetaTags'
import quizImg from './quiz-villes.png'

const QuizCitiesMetaManager = () => (
  <MetaTags
    title={'Jeu : Quiz de géographie des villes de France - Mappy'}
    description={'Quiz géographie : Le jeu pour tester votre connaissance des villes de France sur la carte'}
    image={quizImg}
  />
)

export default QuizCitiesMetaManager
